import axios from '@/lib/axios'
import pinia from '@/stores'
import { useAuthStore } from '@/stores/auth'
import Axios from 'axios'

import type { CustomAxiosRequestConfig } from '@/interfaces/customAxiosRequestConfig'

import { hotelReportAccess } from './hotelReportAccess'

type LocalEndpoint =
	| 'reservations'
	| 'summary'
	| 'trends'
	| 'destinations'
	| 'analytics'
	| 'export'

/** Explicit report boundary: no global interceptors or URL-based permission inference. */
export async function getHotelReport<T = unknown>(
	company: number,
	endpoint: LocalEndpoint | 'legacy' | 'legacy/export' | 'legacy/columns',
	config: CustomAxiosRequestConfig = {}
) {
	const deny = hotelReportAccess.denialHandler(
		useAuthStore(pinia).user?.id,
		company,
		(
			endpoint === 'legacy' ||
				endpoint === 'legacy/export' ||
				endpoint === 'legacy/columns'
		) ?
			'legacy'
		:	'local'
	)
	try {
		return await axios.get<T>(
			`/api/companies/${company}/hotels/reports/${endpoint}`,
			{ ...config, errorHandling: false } as CustomAxiosRequestConfig
		)
	} catch (cause) {
		if (Axios.isAxiosError(cause) && cause.response?.status === 403) {
			let data: unknown = cause.response.data
			if (data instanceof Blob) {
				try {
					data = JSON.parse(await data.text())
				} catch {
					data = null
				}
			}
			const body = data as { reason?: unknown; message?: unknown } | null
			deny(
				typeof body?.reason === 'string' ? body.reason : null,
				typeof body?.message === 'string' ?
					body.message
				:	'Tu acceso al reporte ha cambiado. Consulta con tu administrador.'
			)
		}
		throw cause
	}
}
